<template>
  <div id="app">
    <!-- 全局横屏提示弹窗 -->
    <OrientationTip :showOrientationTip="showOrientationTip" @closeTip="handleCloseTip"/>
    <router-view/>
    <FeedbackModal ref="fbModal" />
  </div>
</template>

<script>
import OrientationTip from '@/components/OrientationTip.vue'
import FeedbackModal from '@/components/FeedbackModal.vue'
export default {
  name: 'App',
  components: {
    OrientationTip,
    FeedbackModal
  },
  data() {
    return {
      showOrientationTip: false,
      userDismissTip: false
    }
  },
  mounted() {
    // 挂全局反馈弹窗方法，任何页面都能 this.$openFeedback()
    this.$root.$openFeedback = () => {
      this.$refs.fbModal.open()
    };
window.__openFeedback = () => {
      if (this.$refs.fbModal) this.$refs.fbModal.open()
    };
    this.setPlatformClass();
    this.setDynamicVH();
    this.checkOrientation();
    window.addEventListener('resize', this.setDynamicVH);
    window.addEventListener('orientationchange', this.setDynamicVH);
    // 新增：屏幕方向检测监听
    window.addEventListener('resize', this.checkOrientation);
    window.addEventListener('orientationchange', this.checkOrientation);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.setDynamicVH);
    window.removeEventListener('orientationchange', this.setDynamicVH);
    // 移除横屏检测监听
    window.removeEventListener('resize', this.checkOrientation);
    window.removeEventListener('orientationchange', this.checkOrientation);
  },
  methods: {
    // 判断iOS/安卓，给html根节点加class，用来写平台补丁样式
    setPlatformClass() {
      const ua = navigator.userAgent;
      // iOS检测，包含iPhone/iPad，还有M1 Mac触摸设备
      const isIOS = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      if (isIOS) {
        document.documentElement.classList.add('platform-ios');
      } else {
        document.documentElement.classList.add('platform-android');
      }
    },
    // 动态 --vh 变量，修复iOS Safari地址栏高度bug
    setDynamicVH() {
      document.documentElement.style.setProperty('--vh', window.innerHeight * 0.01 + 'px');
    },
    // 横屏检测，和index原有逻辑完全一致
    checkOrientation() {
      const w = window.innerWidth
      const h = window.innerHeight
      // 用户手动关闭过后，本次会话不再弹出
      if(this.userDismissTip){
        this.showOrientationTip = false
        return
      }
      if(w < h){
        this.showOrientationTip = true
      }else{
        this.showOrientationTip = false
      }
    },
    handleCloseTip(){
      this.showOrientationTip = false
      this.userDismissTip = true
    }
  }
}
</script>

<style>
*{margin:0;padding:0;box-sizing:border-box;}

html,
body,
#app {
  min-height: 100vh;
  min-height: 100dvh;
  min-height: calc(var(--vh, 1vh) * 100);
  overflow: hidden;
}

/* 全局安全区CSS变量定义 */
:root {
  --safe-top: env(safe-area-inset-top, 0px);
  --safe-right: env(safe-area-inset-right, 0px);
  --safe-bottom: env(safe-area-inset-bottom, 0px);
  --safe-left: env(safe-area-inset-left, 0px);
}

/* iOS专属样式补丁 */
.platform-ios {
  -webkit-overflow-scrolling: touch;
}
.platform-ios input,
.platform-ios textarea {
  -webkit-appearance: none;
  border-radius: 0;
}
</style>